<template>
  <!-- Wraps an el-table (or any wide table) so it scrolls sideways on
       narrow screens instead of crushing its columns. Desktop is unaffected:
       the min-width only applies below 768px. Pass :min-width to tune how
       wide the table stays before scrolling (default 640px). -->
  <div class="table-responsive" :style="{ '--table-min-width': minWidth + 'px' }">
    <slot />
  </div>
</template>

<script>
export default {
  name: "TableResponsive",
  props: {
    minWidth: {
      type: Number,
      default: 640,
    },
  },
};
</script>

<style scoped>
.table-responsive {
  width: 100%;
}
@media (max-width: 767px) {
  .table-responsive {
    overflow-x: auto;
  }
  .table-responsive :deep(.el-table) {
    min-width: var(--table-min-width);
  }
}
</style>
